var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.78.878a.75.75 0 0 0-1.06 0L7.5 7.098 1.28.878a.75.75 0 0 0-1.06 1.06l6.75 6.75a.75.75 0 0 0 1.06 0l6.75-6.75a.75.75 0 0 0 0-1.06",
    clipRule: "evenodd"
  })));
};
export default SvgChevronDown;